import { GraphQLClient } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'graphql-request/build/cjs/types';
import { gql } from 'graphql-request';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
  EditorialContentDynamicZoneInput: { input: any; output: any; }
  I18NLocaleCode: { input: any; output: any; }
  JSON: { input: any; output: any; }
  Upload: { input: any; output: any; }
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Campaign = {
  __typename?: 'Campaign';
  Audio?: Maybe<UploadFileEntityResponse>;
  Background?: Maybe<UploadFileEntityResponse>;
  CurrentNft?: Maybe<ComponentCampaignCurrentNft>;
  Roadmap?: Maybe<Array<Maybe<ComponentCampaignCampaignRoadmap>>>;
  Video?: Maybe<UploadFileEntityResponse>;
  campaignContents?: Maybe<ComponentCampaignCampaignContents>;
  containedNfts?: Maybe<ComponentCampaignContainedNfts>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ctaButton?: Maybe<ComponentCampaignCtaButton>;
  currentNfts?: Maybe<Array<Maybe<ComponentCampaignCurrentNft>>>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<CampaignRelationResponseCollection>;
  newsletterID?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  tokenForge?: Maybe<ComponentCampaignTokenForge>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type CampaignRoadmapArgs = {
  filters?: InputMaybe<ComponentCampaignCampaignRoadmapFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CampaignCurrentNftsArgs = {
  filters?: InputMaybe<ComponentCampaignCurrentNftFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type CampaignLocalizationsArgs = {
  filters?: InputMaybe<CampaignFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type CampaignEntity = {
  __typename?: 'CampaignEntity';
  attributes?: Maybe<Campaign>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type CampaignEntityResponse = {
  __typename?: 'CampaignEntityResponse';
  data?: Maybe<CampaignEntity>;
};

export type CampaignEntityResponseCollection = {
  __typename?: 'CampaignEntityResponseCollection';
  data: Array<CampaignEntity>;
  meta: ResponseCollectionMeta;
};

export type CampaignFiltersInput = {
  CurrentNft?: InputMaybe<ComponentCampaignCurrentNftFiltersInput>;
  Roadmap?: InputMaybe<ComponentCampaignCampaignRoadmapFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<CampaignFiltersInput>>>;
  campaignContents?: InputMaybe<ComponentCampaignCampaignContentsFiltersInput>;
  containedNfts?: InputMaybe<ComponentCampaignContainedNftsFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ctaButton?: InputMaybe<ComponentCampaignCtaButtonFiltersInput>;
  currentNfts?: InputMaybe<ComponentCampaignCurrentNftFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<CampaignFiltersInput>;
  newsletterID?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CampaignFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CampaignFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  tokenForge?: InputMaybe<ComponentCampaignTokenForgeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CampaignInput = {
  Audio?: InputMaybe<Scalars['ID']['input']>;
  Background?: InputMaybe<Scalars['ID']['input']>;
  CurrentNft?: InputMaybe<ComponentCampaignCurrentNftInput>;
  Roadmap?: InputMaybe<Array<InputMaybe<ComponentCampaignCampaignRoadmapInput>>>;
  Video?: InputMaybe<Scalars['ID']['input']>;
  campaignContents?: InputMaybe<ComponentCampaignCampaignContentsInput>;
  containedNfts?: InputMaybe<ComponentCampaignContainedNftsInput>;
  ctaButton?: InputMaybe<ComponentCampaignCtaButtonInput>;
  currentNfts?: InputMaybe<Array<InputMaybe<ComponentCampaignCurrentNftInput>>>;
  newsletterID?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tokenForge?: InputMaybe<ComponentCampaignTokenForgeInput>;
};

export type CampaignRelationResponseCollection = {
  __typename?: 'CampaignRelationResponseCollection';
  data: Array<CampaignEntity>;
};

export type ClaimPage = {
  __typename?: 'ClaimPage';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<ComponentClaimPageDescription>;
  image?: Maybe<UploadFileEntityResponse>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<ClaimPageRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  tokenForge?: Maybe<ComponentNftTokenForge>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ClaimPageLocalizationsArgs = {
  filters?: InputMaybe<ClaimPageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ClaimPageEntity = {
  __typename?: 'ClaimPageEntity';
  attributes?: Maybe<ClaimPage>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type ClaimPageEntityResponse = {
  __typename?: 'ClaimPageEntityResponse';
  data?: Maybe<ClaimPageEntity>;
};

export type ClaimPageEntityResponseCollection = {
  __typename?: 'ClaimPageEntityResponseCollection';
  data: Array<ClaimPageEntity>;
  meta: ResponseCollectionMeta;
};

export type ClaimPageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ClaimPageFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<ComponentClaimPageDescriptionFiltersInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<ClaimPageFiltersInput>;
  not?: InputMaybe<ClaimPageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ClaimPageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  tokenForge?: InputMaybe<ComponentNftTokenForgeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ClaimPageInput = {
  description?: InputMaybe<ComponentClaimPageDescriptionInput>;
  image?: InputMaybe<Scalars['ID']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tokenForge?: InputMaybe<ComponentNftTokenForgeInput>;
};

export type ClaimPageRelationResponseCollection = {
  __typename?: 'ClaimPageRelationResponseCollection';
  data: Array<ClaimPageEntity>;
};

export type ComponentArtistArtist = {
  __typename?: 'ComponentArtistArtist';
  Image?: Maybe<UploadFileEntityResponse>;
  Name?: Maybe<Scalars['String']['output']>;
  URL?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentArtistArtistFiltersInput = {
  Name?: InputMaybe<StringFilterInput>;
  URL?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentArtistArtistFiltersInput>>>;
  not?: InputMaybe<ComponentArtistArtistFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentArtistArtistFiltersInput>>>;
};

export type ComponentArtistArtistInput = {
  Image?: InputMaybe<Scalars['ID']['input']>;
  Name?: InputMaybe<Scalars['String']['input']>;
  URL?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentArtistsTokenForgeUuid = {
  __typename?: 'ComponentArtistsTokenForgeUuid';
  TokenForge_UUID?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentArtistsTokenForgeUuidFiltersInput = {
  TokenForge_UUID?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentArtistsTokenForgeUuidFiltersInput>>>;
  not?: InputMaybe<ComponentArtistsTokenForgeUuidFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentArtistsTokenForgeUuidFiltersInput>>>;
};

export type ComponentArtistsTokenForgeUuidInput = {
  TokenForge_UUID?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCampaignCampaignContents = {
  __typename?: 'ComponentCampaignCampaignContents';
  contents?: Maybe<Array<Maybe<ComponentCampaignContents>>>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  subHeadline?: Maybe<Scalars['String']['output']>;
};


export type ComponentCampaignCampaignContentsContentsArgs = {
  filters?: InputMaybe<ComponentCampaignContentsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCampaignCampaignContentsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCampaignCampaignContentsFiltersInput>>>;
  contents?: InputMaybe<ComponentCampaignContentsFiltersInput>;
  headline?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCampaignCampaignContentsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCampaignCampaignContentsFiltersInput>>>;
  subHeadline?: InputMaybe<StringFilterInput>;
};

export type ComponentCampaignCampaignContentsInput = {
  contents?: InputMaybe<Array<InputMaybe<ComponentCampaignContentsInput>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  subHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCampaignCampaignRoadmap = {
  __typename?: 'ComponentCampaignCampaignRoadmap';
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nftId?: Maybe<Scalars['String']['output']>;
  startAt?: Maybe<Scalars['DateTime']['output']>;
  startAtText?: Maybe<Scalars['String']['output']>;
  subHeadline?: Maybe<Scalars['String']['output']>;
};

export type ComponentCampaignCampaignRoadmapFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCampaignCampaignRoadmapFiltersInput>>>;
  headline?: InputMaybe<StringFilterInput>;
  nftId?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCampaignCampaignRoadmapFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCampaignCampaignRoadmapFiltersInput>>>;
  startAt?: InputMaybe<DateTimeFilterInput>;
  startAtText?: InputMaybe<StringFilterInput>;
  subHeadline?: InputMaybe<StringFilterInput>;
};

export type ComponentCampaignCampaignRoadmapInput = {
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  nftId?: InputMaybe<Scalars['String']['input']>;
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  startAtText?: InputMaybe<Scalars['String']['input']>;
  subHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCampaignContainedNfts = {
  __typename?: 'ComponentCampaignContainedNfts';
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  subHeadline?: Maybe<Scalars['String']['output']>;
};

export type ComponentCampaignContainedNftsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCampaignContainedNftsFiltersInput>>>;
  headline?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCampaignContainedNftsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCampaignContainedNftsFiltersInput>>>;
  subHeadline?: InputMaybe<StringFilterInput>;
};

export type ComponentCampaignContainedNftsInput = {
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentCampaignContents = {
  __typename?: 'ComponentCampaignContents';
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
};

export type ComponentCampaignContentsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCampaignContentsFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  headline?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCampaignContentsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCampaignContentsFiltersInput>>>;
};

export type ComponentCampaignContentsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCampaignCtaButton = {
  __typename?: 'ComponentCampaignCtaButton';
  buttonTitle?: Maybe<Scalars['String']['output']>;
  enable?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentCampaignCtaButtonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCampaignCtaButtonFiltersInput>>>;
  buttonTitle?: InputMaybe<StringFilterInput>;
  enable?: InputMaybe<BooleanFilterInput>;
  not?: InputMaybe<ComponentCampaignCtaButtonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCampaignCtaButtonFiltersInput>>>;
};

export type ComponentCampaignCtaButtonInput = {
  buttonTitle?: InputMaybe<Scalars['String']['input']>;
  enable?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCampaignCurrentNft = {
  __typename?: 'ComponentCampaignCurrentNft';
  contents?: Maybe<Array<Maybe<ComponentCurrentNftContentsContents>>>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  nftId?: Maybe<Scalars['String']['output']>;
  subHeadline?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Enum_Componentcampaigncurrentnft_Type>;
};


export type ComponentCampaignCurrentNftContentsArgs = {
  filters?: InputMaybe<ComponentCurrentNftContentsContentsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCampaignCurrentNftFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCampaignCurrentNftFiltersInput>>>;
  contents?: InputMaybe<ComponentCurrentNftContentsContentsFiltersInput>;
  headline?: InputMaybe<StringFilterInput>;
  nftId?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCampaignCurrentNftFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCampaignCurrentNftFiltersInput>>>;
  subHeadline?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  type?: InputMaybe<StringFilterInput>;
};

export type ComponentCampaignCurrentNftInput = {
  contents?: InputMaybe<Array<InputMaybe<ComponentCurrentNftContentsContentsInput>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  nftId?: InputMaybe<Scalars['String']['input']>;
  subHeadline?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Enum_Componentcampaigncurrentnft_Type>;
};

export type ComponentCampaignTokenForge = {
  __typename?: 'ComponentCampaignTokenForge';
  Artists?: Maybe<Array<Maybe<ComponentArtistsTokenForgeUuid>>>;
  campaignId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};


export type ComponentCampaignTokenForgeArtistsArgs = {
  filters?: InputMaybe<ComponentArtistsTokenForgeUuidFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentCampaignTokenForgeFiltersInput = {
  Artists?: InputMaybe<ComponentArtistsTokenForgeUuidFiltersInput>;
  and?: InputMaybe<Array<InputMaybe<ComponentCampaignTokenForgeFiltersInput>>>;
  campaignId?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCampaignTokenForgeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCampaignTokenForgeFiltersInput>>>;
};

export type ComponentCampaignTokenForgeInput = {
  Artists?: InputMaybe<Array<InputMaybe<ComponentArtistsTokenForgeUuidInput>>>;
  campaignId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentClaimPageDescription = {
  __typename?: 'ComponentClaimPageDescription';
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type ComponentClaimPageDescriptionFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentClaimPageDescriptionFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  headline?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentClaimPageDescriptionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentClaimPageDescriptionFiltersInput>>>;
};

export type ComponentClaimPageDescriptionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentCurrentNftContentsContents = {
  __typename?: 'ComponentCurrentNftContentsContents';
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageAlt?: Maybe<Scalars['String']['output']>;
  imageUrl?: Maybe<UploadFileEntityResponse>;
};

export type ComponentCurrentNftContentsContentsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentCurrentNftContentsContentsFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  headline?: InputMaybe<StringFilterInput>;
  imageAlt?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentCurrentNftContentsContentsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentCurrentNftContentsContentsFiltersInput>>>;
};

export type ComponentCurrentNftContentsContentsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  imageAlt?: InputMaybe<Scalars['String']['input']>;
  imageUrl?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentEditorialEntries = {
  __typename?: 'ComponentEditorialEntries';
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  thumbnail?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentEditorialGallery = {
  __typename?: 'ComponentEditorialGallery';
  id: Scalars['ID']['output'];
  images?: Maybe<UploadFileRelationResponseCollection>;
};


export type ComponentEditorialGalleryImagesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentEditorialImage = {
  __typename?: 'ComponentEditorialImage';
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
};

export type ComponentEditorialIntro = {
  __typename?: 'ComponentEditorialIntro';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type ComponentEditorialMainImage = {
  __typename?: 'ComponentEditorialMainImage';
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
};

export type ComponentEditorialQuotation = {
  __typename?: 'ComponentEditorialQuotation';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type ComponentEditorialText = {
  __typename?: 'ComponentEditorialText';
  id: Scalars['ID']['output'];
  text?: Maybe<Scalars['String']['output']>;
};

export type ComponentHottestDropsHottesOfDrops = {
  __typename?: 'ComponentHottestDropsHottesOfDrops';
  campaign_link?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  gallery?: Maybe<UploadFileRelationResponseCollection>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nft?: Maybe<NftEntityResponse>;
};


export type ComponentHottestDropsHottesOfDropsGalleryArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentHottestDropsHottesOfDropsInput = {
  campaign_link?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  gallery?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nft?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentHottestDropsHottestsDrops = {
  __typename?: 'ComponentHottestDropsHottestsDrops';
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
  nft?: Maybe<NftEntityResponse>;
};

export type ComponentHottestDropsHottestsDropsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentHottestDropsHottestsDropsFiltersInput>>>;
  nft?: InputMaybe<NftFiltersInput>;
  not?: InputMaybe<ComponentHottestDropsHottestsDropsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentHottestDropsHottestsDropsFiltersInput>>>;
};

export type ComponentHottestDropsHottestsDropsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  nft?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentNftBackground = {
  __typename?: 'ComponentNftBackground';
  id: Scalars['ID']['output'];
};

export type ComponentNftContentLinks = {
  __typename?: 'ComponentNftContentLinks';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  type?: Maybe<Enum_Componentnftcontentlinks_Type>;
  url?: Maybe<Scalars['String']['output']>;
};

export type ComponentNftContentLinksFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNftContentLinksFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentNftContentLinksFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNftContentLinksFiltersInput>>>;
  type?: InputMaybe<StringFilterInput>;
  url?: InputMaybe<StringFilterInput>;
};

export type ComponentNftContentLinksInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<Enum_Componentnftcontentlinks_Type>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNftNftContent = {
  __typename?: 'ComponentNftNftContent';
  id: Scalars['ID']['output'];
  links?: Maybe<Array<Maybe<ComponentNftContentLinks>>>;
};


export type ComponentNftNftContentLinksArgs = {
  filters?: InputMaybe<ComponentNftContentLinksFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ComponentNftNftContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNftNftContentFiltersInput>>>;
  links?: InputMaybe<ComponentNftContentLinksFiltersInput>;
  not?: InputMaybe<ComponentNftNftContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNftNftContentFiltersInput>>>;
};

export type ComponentNftNftContentInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  links?: InputMaybe<Array<InputMaybe<ComponentNftContentLinksInput>>>;
};

export type ComponentNftTokenForge = {
  __typename?: 'ComponentNftTokenForge';
  id: Scalars['ID']['output'];
  nftId?: Maybe<Scalars['String']['output']>;
  pageSlug?: Maybe<Scalars['String']['output']>;
};

export type ComponentNftTokenForgeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNftTokenForgeFiltersInput>>>;
  nftId?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentNftTokenForgeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNftTokenForgeFiltersInput>>>;
  pageSlug?: InputMaybe<StringFilterInput>;
};

export type ComponentNftTokenForgeInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  nftId?: InputMaybe<Scalars['String']['input']>;
  pageSlug?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentNftTokenType = {
  __typename?: 'ComponentNftTokenType';
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  iconUrl?: Maybe<UploadFileEntityResponse>;
  id: Scalars['ID']['output'];
  subHeadline?: Maybe<Scalars['String']['output']>;
};

export type ComponentNftTokenTypeFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentNftTokenTypeFiltersInput>>>;
  description?: InputMaybe<StringFilterInput>;
  headline?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentNftTokenTypeFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentNftTokenTypeFiltersInput>>>;
  subHeadline?: InputMaybe<StringFilterInput>;
};

export type ComponentNftTokenTypeInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  iconUrl?: InputMaybe<Scalars['ID']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  subHeadline?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentUpcomingDropsUpcomingDrops = {
  __typename?: 'ComponentUpcomingDropsUpcomingDrops';
  id: Scalars['ID']['output'];
  nft?: Maybe<NftEntityResponse>;
};

export type ComponentUpcomingDropsUpcomingDropsFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentUpcomingDropsUpcomingDropsFiltersInput>>>;
  nft?: InputMaybe<NftFiltersInput>;
  not?: InputMaybe<ComponentUpcomingDropsUpcomingDropsFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentUpcomingDropsUpcomingDropsFiltersInput>>>;
};

export type ComponentUpcomingDropsUpcomingDropsInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  nft?: InputMaybe<Scalars['ID']['input']>;
};

export type ComponentWhatWeDoButton = {
  __typename?: 'ComponentWhatWeDoButton';
  id: Scalars['ID']['output'];
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ComponentWhatWeDoButtonFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentWhatWeDoButtonFiltersInput>>>;
  link?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentWhatWeDoButtonFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentWhatWeDoButtonFiltersInput>>>;
  title?: InputMaybe<StringFilterInput>;
};

export type ComponentWhatWeDoButtonInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type ComponentWhatWeDoContent = {
  __typename?: 'ComponentWhatWeDoContent';
  button?: Maybe<ComponentWhatWeDoButton>;
  comingSoon?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  headline?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<UploadFileEntityResponse>;
};

export type ComponentWhatWeDoContentFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ComponentWhatWeDoContentFiltersInput>>>;
  button?: InputMaybe<ComponentWhatWeDoButtonFiltersInput>;
  comingSoon?: InputMaybe<BooleanFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  headline?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ComponentWhatWeDoContentFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ComponentWhatWeDoContentFiltersInput>>>;
};

export type ComponentWhatWeDoContentInput = {
  button?: InputMaybe<ComponentWhatWeDoButtonInput>;
  comingSoon?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  headline?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export enum Enum_Componentcampaigncurrentnft_Type {
  Airdrop = 'airdrop',
  Auction = 'auction',
  Standard = 'standard'
}

export enum Enum_Componentnftcontentlinks_Type {
  Discord = 'Discord',
  Metaverse = 'Metaverse'
}

export type Editorial = {
  __typename?: 'Editorial';
  author?: Maybe<Scalars['String']['output']>;
  category?: Maybe<EditorialCategoryEntityResponse>;
  content?: Maybe<Array<Maybe<EditorialContentDynamicZone>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  externalEntry?: Maybe<Scalars['String']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<EditorialRelationResponseCollection>;
  mainImage?: Maybe<UploadFileEntityResponse>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<UploadFileEntityResponse>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type EditorialLocalizationsArgs = {
  filters?: InputMaybe<EditorialFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EditorialCategory = {
  __typename?: 'EditorialCategory';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<EditorialCategoryRelationResponseCollection>;
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type EditorialCategoryLocalizationsArgs = {
  filters?: InputMaybe<EditorialCategoryFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type EditorialCategoryEntity = {
  __typename?: 'EditorialCategoryEntity';
  attributes?: Maybe<EditorialCategory>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EditorialCategoryEntityResponse = {
  __typename?: 'EditorialCategoryEntityResponse';
  data?: Maybe<EditorialCategoryEntity>;
};

export type EditorialCategoryEntityResponseCollection = {
  __typename?: 'EditorialCategoryEntityResponseCollection';
  data: Array<EditorialCategoryEntity>;
  meta: ResponseCollectionMeta;
};

export type EditorialCategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EditorialCategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<EditorialCategoryFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EditorialCategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EditorialCategoryFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EditorialCategoryInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type EditorialCategoryRelationResponseCollection = {
  __typename?: 'EditorialCategoryRelationResponseCollection';
  data: Array<EditorialCategoryEntity>;
};

export type EditorialContentDynamicZone = ComponentEditorialGallery | ComponentEditorialImage | ComponentEditorialIntro | ComponentEditorialQuotation | ComponentEditorialText | Error;

export type EditorialEntity = {
  __typename?: 'EditorialEntity';
  attributes?: Maybe<Editorial>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type EditorialEntityResponse = {
  __typename?: 'EditorialEntityResponse';
  data?: Maybe<EditorialEntity>;
};

export type EditorialEntityResponseCollection = {
  __typename?: 'EditorialEntityResponseCollection';
  data: Array<EditorialEntity>;
  meta: ResponseCollectionMeta;
};

export type EditorialFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<EditorialFiltersInput>>>;
  author?: InputMaybe<StringFilterInput>;
  category?: InputMaybe<EditorialCategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  externalEntry?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<EditorialFiltersInput>;
  metaDescription?: InputMaybe<StringFilterInput>;
  metaTitle?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<EditorialFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<EditorialFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type EditorialInput = {
  author?: InputMaybe<Scalars['String']['input']>;
  category?: InputMaybe<Scalars['ID']['input']>;
  content?: InputMaybe<Array<Scalars['EditorialContentDynamicZoneInput']['input']>>;
  externalEntry?: InputMaybe<Scalars['String']['input']>;
  mainImage?: InputMaybe<Scalars['ID']['input']>;
  metaDescription?: InputMaybe<Scalars['String']['input']>;
  metaTitle?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  thumbnail?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type EditorialRelationResponseCollection = {
  __typename?: 'EditorialRelationResponseCollection';
  data: Array<EditorialEntity>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph = Campaign | ClaimPage | ComponentArtistArtist | ComponentArtistsTokenForgeUuid | ComponentCampaignCampaignContents | ComponentCampaignCampaignRoadmap | ComponentCampaignContainedNfts | ComponentCampaignContents | ComponentCampaignCtaButton | ComponentCampaignCurrentNft | ComponentCampaignTokenForge | ComponentClaimPageDescription | ComponentCurrentNftContentsContents | ComponentEditorialEntries | ComponentEditorialGallery | ComponentEditorialImage | ComponentEditorialIntro | ComponentEditorialMainImage | ComponentEditorialQuotation | ComponentEditorialText | ComponentHottestDropsHottesOfDrops | ComponentHottestDropsHottestsDrops | ComponentNftBackground | ComponentNftContentLinks | ComponentNftNftContent | ComponentNftTokenForge | ComponentNftTokenType | ComponentUpcomingDropsUpcomingDrops | ComponentWhatWeDoButton | ComponentWhatWeDoContent | Editorial | EditorialCategory | HottestDrop | I18NLocale | NewArtist | Nft | UpcomingDrop | UploadFile | UsersPermissionsPermission | UsersPermissionsRole | UsersPermissionsUser | WhatWeDo;

export type HottestDrop = {
  __typename?: 'HottestDrop';
  HottestDrops?: Maybe<Array<Maybe<ComponentHottestDropsHottestsDrops>>>;
  HottestOfDrops?: Maybe<ComponentHottestDropsHottesOfDrops>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type HottestDropHottestDropsArgs = {
  filters?: InputMaybe<ComponentHottestDropsHottestsDropsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HottestDropEntity = {
  __typename?: 'HottestDropEntity';
  attributes?: Maybe<HottestDrop>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type HottestDropEntityResponse = {
  __typename?: 'HottestDropEntityResponse';
  data?: Maybe<HottestDropEntity>;
};

export type HottestDropInput = {
  HottestDrops?: InputMaybe<Array<InputMaybe<ComponentHottestDropsHottestsDropsInput>>>;
  HottestOfDrops?: InputMaybe<ComponentHottestDropsHottesOfDropsInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntity = {
  __typename?: 'I18NLocaleEntity';
  attributes?: Maybe<I18NLocale>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type I18NLocaleEntityResponse = {
  __typename?: 'I18NLocaleEntityResponse';
  data?: Maybe<I18NLocaleEntity>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  data: Array<I18NLocaleEntity>;
  meta: ResponseCollectionMeta;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  createCampaign?: Maybe<CampaignEntityResponse>;
  createCampaignLocalization?: Maybe<CampaignEntityResponse>;
  createClaimPage?: Maybe<ClaimPageEntityResponse>;
  createClaimPageLocalization?: Maybe<ClaimPageEntityResponse>;
  createEditorial?: Maybe<EditorialEntityResponse>;
  createEditorialCategory?: Maybe<EditorialCategoryEntityResponse>;
  createEditorialCategoryLocalization?: Maybe<EditorialCategoryEntityResponse>;
  createEditorialLocalization?: Maybe<EditorialEntityResponse>;
  createNewArtistLocalization?: Maybe<NewArtistEntityResponse>;
  createNft?: Maybe<NftEntityResponse>;
  createNftLocalization?: Maybe<NftEntityResponse>;
  createUploadFile?: Maybe<UploadFileEntityResponse>;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  /** Create a new user */
  createUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteCampaign?: Maybe<CampaignEntityResponse>;
  deleteClaimPage?: Maybe<ClaimPageEntityResponse>;
  deleteEditorial?: Maybe<EditorialEntityResponse>;
  deleteEditorialCategory?: Maybe<EditorialCategoryEntityResponse>;
  deleteHottestDrop?: Maybe<HottestDropEntityResponse>;
  deleteNewArtist?: Maybe<NewArtistEntityResponse>;
  deleteNft?: Maybe<NftEntityResponse>;
  deleteUpcomingDrop?: Maybe<UpcomingDropEntityResponse>;
  deleteUploadFile?: Maybe<UploadFileEntityResponse>;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  /** Delete an existing user */
  deleteUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  deleteWhatWeDo?: Maybe<WhatWeDoEntityResponse>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  multipleUpload: Array<Maybe<UploadFileEntityResponse>>;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  removeFile?: Maybe<UploadFileEntityResponse>;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateCampaign?: Maybe<CampaignEntityResponse>;
  updateClaimPage?: Maybe<ClaimPageEntityResponse>;
  updateEditorial?: Maybe<EditorialEntityResponse>;
  updateEditorialCategory?: Maybe<EditorialCategoryEntityResponse>;
  updateFileInfo: UploadFileEntityResponse;
  updateHottestDrop?: Maybe<HottestDropEntityResponse>;
  updateNewArtist?: Maybe<NewArtistEntityResponse>;
  updateNft?: Maybe<NftEntityResponse>;
  updateUpcomingDrop?: Maybe<UpcomingDropEntityResponse>;
  updateUploadFile?: Maybe<UploadFileEntityResponse>;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  /** Update an existing user */
  updateUsersPermissionsUser: UsersPermissionsUserEntityResponse;
  updateWhatWeDo?: Maybe<WhatWeDoEntityResponse>;
  upload: UploadFileEntityResponse;
};


export type MutationCreateCampaignArgs = {
  data: CampaignInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateCampaignLocalizationArgs = {
  data?: InputMaybe<CampaignInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateClaimPageArgs = {
  data: ClaimPageInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateClaimPageLocalizationArgs = {
  data?: InputMaybe<ClaimPageInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateEditorialArgs = {
  data: EditorialInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateEditorialCategoryArgs = {
  data: EditorialCategoryInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateEditorialCategoryLocalizationArgs = {
  data?: InputMaybe<EditorialCategoryInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateEditorialLocalizationArgs = {
  data?: InputMaybe<EditorialInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateNewArtistLocalizationArgs = {
  data?: InputMaybe<NewArtistInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateNftArgs = {
  data: NftInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateNftLocalizationArgs = {
  data?: InputMaybe<NftInput>;
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationCreateUploadFileArgs = {
  data: UploadFileInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationCreateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
};


export type MutationDeleteCampaignArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteClaimPageArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteEditorialArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteEditorialCategoryArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteNewArtistArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteNftArgs = {
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationMultipleUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  files: Array<InputMaybe<Scalars['Upload']['input']>>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationRemoveFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateCampaignArgs = {
  data: CampaignInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateClaimPageArgs = {
  data: ClaimPageInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateEditorialArgs = {
  data: EditorialInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateEditorialCategoryArgs = {
  data: EditorialCategoryInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateFileInfoArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateHottestDropArgs = {
  data: HottestDropInput;
};


export type MutationUpdateNewArtistArgs = {
  data: NewArtistInput;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateNftArgs = {
  data: NftInput;
  id: Scalars['ID']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type MutationUpdateUpcomingDropArgs = {
  data: UpcomingDropInput;
};


export type MutationUpdateUploadFileArgs = {
  data: UploadFileInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsUserArgs = {
  data: UsersPermissionsUserInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateWhatWeDoArgs = {
  data: WhatWeDoInput;
};


export type MutationUploadArgs = {
  field?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  info?: InputMaybe<FileInfoInput>;
  ref?: InputMaybe<Scalars['String']['input']>;
  refId?: InputMaybe<Scalars['ID']['input']>;
};

export type NewArtist = {
  __typename?: 'NewArtist';
  Artist?: Maybe<Array<Maybe<ComponentArtistArtist>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<NewArtistRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type NewArtistArtistArgs = {
  filters?: InputMaybe<ComponentArtistArtistFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type NewArtistLocalizationsArgs = {
  publicationState?: InputMaybe<PublicationState>;
};

export type NewArtistEntity = {
  __typename?: 'NewArtistEntity';
  attributes?: Maybe<NewArtist>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NewArtistEntityResponse = {
  __typename?: 'NewArtistEntityResponse';
  data?: Maybe<NewArtistEntity>;
};

export type NewArtistInput = {
  Artist?: InputMaybe<Array<InputMaybe<ComponentArtistArtistInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type NewArtistRelationResponseCollection = {
  __typename?: 'NewArtistRelationResponseCollection';
  data: Array<NewArtistEntity>;
};

export type Nft = {
  __typename?: 'Nft';
  background?: Maybe<UploadFileEntityResponse>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  locale?: Maybe<Scalars['String']['output']>;
  localizations?: Maybe<NftRelationResponseCollection>;
  name?: Maybe<Scalars['String']['output']>;
  nftContent?: Maybe<ComponentNftNftContent>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  tokenForge?: Maybe<ComponentNftTokenForge>;
  tokenType?: Maybe<ComponentNftTokenType>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type NftLocalizationsArgs = {
  filters?: InputMaybe<NftFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type NftEntity = {
  __typename?: 'NftEntity';
  attributes?: Maybe<Nft>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type NftEntityResponse = {
  __typename?: 'NftEntityResponse';
  data?: Maybe<NftEntity>;
};

export type NftEntityResponseCollection = {
  __typename?: 'NftEntityResponseCollection';
  data: Array<NftEntity>;
  meta: ResponseCollectionMeta;
};

export type NftFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<NftFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  locale?: InputMaybe<StringFilterInput>;
  localizations?: InputMaybe<NftFiltersInput>;
  name?: InputMaybe<StringFilterInput>;
  nftContent?: InputMaybe<ComponentNftNftContentFiltersInput>;
  not?: InputMaybe<NftFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<NftFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  tokenForge?: InputMaybe<ComponentNftTokenForgeFiltersInput>;
  tokenType?: InputMaybe<ComponentNftTokenTypeFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type NftInput = {
  background?: InputMaybe<Scalars['ID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nftContent?: InputMaybe<ComponentNftNftContentInput>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  tokenForge?: InputMaybe<ComponentNftTokenForgeInput>;
  tokenType?: InputMaybe<ComponentNftTokenTypeInput>;
};

export type NftRelationResponseCollection = {
  __typename?: 'NftRelationResponseCollection';
  data: Array<NftEntity>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export enum PublicationState {
  Live = 'LIVE',
  Preview = 'PREVIEW'
}

export type Query = {
  __typename?: 'Query';
  campaign?: Maybe<CampaignEntityResponse>;
  campaigns?: Maybe<CampaignEntityResponseCollection>;
  claimPage?: Maybe<ClaimPageEntityResponse>;
  claimPages?: Maybe<ClaimPageEntityResponseCollection>;
  editorial?: Maybe<EditorialEntityResponse>;
  editorialCategories?: Maybe<EditorialCategoryEntityResponseCollection>;
  editorialCategory?: Maybe<EditorialCategoryEntityResponse>;
  editorials?: Maybe<EditorialEntityResponseCollection>;
  hottestDrop?: Maybe<HottestDropEntityResponse>;
  i18NLocale?: Maybe<I18NLocaleEntityResponse>;
  i18NLocales?: Maybe<I18NLocaleEntityResponseCollection>;
  me?: Maybe<UsersPermissionsMe>;
  newArtist?: Maybe<NewArtistEntityResponse>;
  nft?: Maybe<NftEntityResponse>;
  nfts?: Maybe<NftEntityResponseCollection>;
  upcomingDrop?: Maybe<UpcomingDropEntityResponse>;
  uploadFile?: Maybe<UploadFileEntityResponse>;
  uploadFiles?: Maybe<UploadFileEntityResponseCollection>;
  usersPermissionsRole?: Maybe<UsersPermissionsRoleEntityResponse>;
  usersPermissionsRoles?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  usersPermissionsUser?: Maybe<UsersPermissionsUserEntityResponse>;
  usersPermissionsUsers?: Maybe<UsersPermissionsUserEntityResponseCollection>;
  whatWeDo?: Maybe<WhatWeDoEntityResponse>;
};


export type QueryCampaignArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryCampaignsArgs = {
  filters?: InputMaybe<CampaignFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryClaimPageArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryClaimPagesArgs = {
  filters?: InputMaybe<ClaimPageFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEditorialArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryEditorialCategoriesArgs = {
  filters?: InputMaybe<EditorialCategoryFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryEditorialCategoryArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryEditorialsArgs = {
  filters?: InputMaybe<EditorialFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryHottestDropArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryI18NLocaleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryNewArtistArgs = {
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryNftArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
};


export type QueryNftsArgs = {
  filters?: InputMaybe<NftFiltersInput>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationState?: InputMaybe<PublicationState>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUpcomingDropArgs = {
  publicationState?: InputMaybe<PublicationState>;
};


export type QueryUploadFileArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsRoleArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryUsersPermissionsUserArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryUsersPermissionsUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryWhatWeDoArgs = {
  publicationState?: InputMaybe<PublicationState>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type UpcomingDrop = {
  __typename?: 'UpcomingDrop';
  UpcomingDrops?: Maybe<Array<Maybe<ComponentUpcomingDropsUpcomingDrops>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type UpcomingDropUpcomingDropsArgs = {
  filters?: InputMaybe<ComponentUpcomingDropsUpcomingDropsFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpcomingDropEntity = {
  __typename?: 'UpcomingDropEntity';
  attributes?: Maybe<UpcomingDrop>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UpcomingDropEntityResponse = {
  __typename?: 'UpcomingDropEntityResponse';
  data?: Maybe<UpcomingDropEntity>;
};

export type UpcomingDropInput = {
  UpcomingDrops?: InputMaybe<Array<InputMaybe<ComponentUpcomingDropsUpcomingDropsInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  ext?: Maybe<Scalars['String']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntity = {
  __typename?: 'UploadFileEntity';
  attributes?: Maybe<UploadFile>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UploadFileEntityResponse = {
  __typename?: 'UploadFileEntityResponse';
  data?: Maybe<UploadFileEntity>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  data: Array<UploadFileEntity>;
  meta: ResponseCollectionMeta;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type UploadFileInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  ext?: InputMaybe<Scalars['String']['input']>;
  formats?: InputMaybe<Scalars['JSON']['input']>;
  hash?: InputMaybe<Scalars['String']['input']>;
  height?: InputMaybe<Scalars['Int']['input']>;
  mime?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  previewUrl?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  provider_metadata?: InputMaybe<Scalars['JSON']['input']>;
  size?: InputMaybe<Scalars['Float']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  width?: InputMaybe<Scalars['Int']['input']>;
};

export type UploadFileRelationResponseCollection = {
  __typename?: 'UploadFileRelationResponseCollection';
  data: Array<UploadFileEntity>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionEntity = {
  __typename?: 'UsersPermissionsPermissionEntity';
  attributes?: Maybe<UsersPermissionsPermission>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  data: Array<UsersPermissionsPermissionEntity>;
};

export type UsersPermissionsRegisterInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  permissions?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users?: Maybe<UsersPermissionsUserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UsersPermissionsUserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntity = {
  __typename?: 'UsersPermissionsRoleEntity';
  attributes?: Maybe<UsersPermissionsRole>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsRoleEntityResponse = {
  __typename?: 'UsersPermissionsRoleEntityResponse';
  data?: Maybe<UsersPermissionsRoleEntity>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  data: Array<UsersPermissionsRoleEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UsersPermissionsUserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsUser = {
  __typename?: 'UsersPermissionsUser';
  blocked?: Maybe<Scalars['Boolean']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsRoleEntityResponse>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
};

export type UsersPermissionsUserEntity = {
  __typename?: 'UsersPermissionsUserEntity';
  attributes?: Maybe<UsersPermissionsUser>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type UsersPermissionsUserEntityResponse = {
  __typename?: 'UsersPermissionsUserEntityResponse';
  data?: Maybe<UsersPermissionsUserEntity>;
};

export type UsersPermissionsUserEntityResponseCollection = {
  __typename?: 'UsersPermissionsUserEntityResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
  meta: ResponseCollectionMeta;
};

export type UsersPermissionsUserFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  blocked?: InputMaybe<BooleanFilterInput>;
  confirmationToken?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  id?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsUserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsUserFiltersInput>>>;
  password?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  resetPasswordToken?: InputMaybe<StringFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
};

export type UsersPermissionsUserInput = {
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsUserRelationResponseCollection = {
  __typename?: 'UsersPermissionsUserRelationResponseCollection';
  data: Array<UsersPermissionsUserEntity>;
};

export type WhatWeDo = {
  __typename?: 'WhatWeDo';
  content?: Maybe<Array<Maybe<ComponentWhatWeDoContent>>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type WhatWeDoContentArgs = {
  filters?: InputMaybe<ComponentWhatWeDoContentFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type WhatWeDoEntity = {
  __typename?: 'WhatWeDoEntity';
  attributes?: Maybe<WhatWeDo>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type WhatWeDoEntityResponse = {
  __typename?: 'WhatWeDoEntityResponse';
  data?: Maybe<WhatWeDoEntity>;
};

export type WhatWeDoInput = {
  content?: InputMaybe<Array<InputMaybe<ComponentWhatWeDoContentInput>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type GetCampaignByCampaignIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  currentNftsPage: Scalars['Int']['input'];
  currentNftsPageSize: Scalars['Int']['input'];
}>;


export type GetCampaignByCampaignIdQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', newsletterID?: string | null, ctaButton?: { __typename?: 'ComponentCampaignCtaButton', enable?: boolean | null, buttonTitle?: string | null } | null, tokenForge?: { __typename?: 'ComponentCampaignTokenForge', id: string, campaignId?: string | null, Artists?: Array<{ __typename?: 'ComponentArtistsTokenForgeUuid', id: string, TokenForge_UUID?: string | null } | null> | null } | null, Background?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, Video?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, Audio?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null, CurrentNft?: { __typename?: 'ComponentCampaignCurrentNft', id: string, nftId?: string | null, title?: string | null, type?: Enum_Componentcampaigncurrentnft_Type | null, headline?: string | null, subHeadline?: string | null, contents?: Array<{ __typename?: 'ComponentCurrentNftContentsContents', id: string, headline?: string | null, description?: string | null, imageAlt?: string | null, imageUrl?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null> | null } | null, currentNfts?: Array<{ __typename?: 'ComponentCampaignCurrentNft', id: string, nftId?: string | null, title?: string | null, type?: Enum_Componentcampaigncurrentnft_Type | null, headline?: string | null, subHeadline?: string | null, contents?: Array<{ __typename?: 'ComponentCurrentNftContentsContents', id: string, headline?: string | null, description?: string | null, imageAlt?: string | null, imageUrl?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null> | null } | null> | null, containedNfts?: { __typename?: 'ComponentCampaignContainedNfts', headline?: string | null, subHeadline?: string | null } | null, Roadmap?: Array<{ __typename?: 'ComponentCampaignCampaignRoadmap', nftId?: string | null, headline?: string | null, subHeadline?: string | null, startAt?: any | null, startAtText?: string | null } | null> | null, campaignContents?: { __typename?: 'ComponentCampaignCampaignContents', headline?: string | null, subHeadline?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, contents?: Array<{ __typename?: 'ComponentCampaignContents', headline?: string | null, description?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | null } | null }> } | null };

export type GetCampaignsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCampaignsQuery = { __typename?: 'Query', campaigns?: { __typename?: 'CampaignEntityResponseCollection', data: Array<{ __typename?: 'CampaignEntity', id?: string | null, attributes?: { __typename?: 'Campaign', CurrentNft?: { __typename?: 'ComponentCampaignCurrentNft', nftId?: string | null } | null, tokenForge?: { __typename?: 'ComponentCampaignTokenForge', id: string, campaignId?: string | null } | null } | null }> } | null };

export type GetClaimByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetClaimByIdQuery = { __typename?: 'Query', claimPages?: { __typename?: 'ClaimPageEntityResponseCollection', data: Array<{ __typename?: 'ClaimPageEntity', attributes?: { __typename?: 'ClaimPage', tokenForge?: { __typename?: 'ComponentNftTokenForge', nftId?: string | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, description?: { __typename?: 'ComponentClaimPageDescription', description?: string | null, headline?: string | null } | null } | null }> } | null };

export type EditorialsFragment = { __typename?: 'Query', editorials?: { __typename?: 'EditorialEntityResponseCollection', data: Array<{ __typename?: 'EditorialEntity', id?: string | null, attributes?: { __typename?: 'Editorial', title?: string | null, author?: string | null, slug?: string | null, createdAt?: any | null, publishedAt?: any | null, externalEntry?: string | null, mainImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, name: string, previewUrl?: string | null, url: string, height?: number | null, width?: number | null } | null } | null } | null, content?: Array<{ __typename: 'ComponentEditorialGallery' } | { __typename: 'ComponentEditorialImage', id: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, name: string, previewUrl?: string | null, url: string, height?: number | null, width?: number | null } | null } | null } | null } | { __typename: 'ComponentEditorialIntro', id: string, text?: string | null } | { __typename: 'ComponentEditorialQuotation', id: string, text?: string | null } | { __typename: 'ComponentEditorialText', id: string, text?: string | null } | { __typename: 'Error' } | null> | null, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, name: string, mime: string, height?: number | null, width?: number | null, url: string } | null } | null } | null, category?: { __typename?: 'EditorialCategoryEntityResponse', data?: { __typename?: 'EditorialCategoryEntity', attributes?: { __typename?: 'EditorialCategory', name?: string | null, slug?: string | null } | null } | null } | null } | null }> } | null };

export type GetEditorialsEqualsSlugQueryVariables = Exact<{
  slug: Scalars['String']['input'];
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetEditorialsEqualsSlugQuery = { __typename?: 'Query', editorials?: { __typename?: 'EditorialEntityResponseCollection', data: Array<{ __typename?: 'EditorialEntity', id?: string | null, attributes?: { __typename?: 'Editorial', title?: string | null, author?: string | null, slug?: string | null, createdAt?: any | null, publishedAt?: any | null, mainImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, name: string, previewUrl?: string | null, url: string, height?: number | null, width?: number | null } | null } | null } | null, content?: Array<{ __typename: 'ComponentEditorialGallery' } | { __typename: 'ComponentEditorialImage', id: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, name: string, previewUrl?: string | null, url: string, height?: number | null, width?: number | null } | null } | null } | null } | { __typename: 'ComponentEditorialIntro', id: string, text?: string | null } | { __typename: 'ComponentEditorialQuotation', id: string, text?: string | null } | { __typename: 'ComponentEditorialText', id: string, text?: string | null } | { __typename: 'Error' } | null> | null, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, name: string, mime: string, height?: number | null, width?: number | null, url: string } | null } | null } | null, category?: { __typename?: 'EditorialCategoryEntityResponse', data?: { __typename?: 'EditorialCategoryEntity', attributes?: { __typename?: 'EditorialCategory', name?: string | null, slug?: string | null } | null } | null } | null } | null }> } | null };

export type GetEditorialCategoriesQueryVariables = Exact<{
  locale: Scalars['I18NLocaleCode']['input'];
}>;


export type GetEditorialCategoriesQuery = { __typename?: 'Query', editorialCategories?: { __typename?: 'EditorialCategoryEntityResponseCollection', data: Array<{ __typename?: 'EditorialCategoryEntity', id?: string | null, attributes?: { __typename?: 'EditorialCategory', name?: string | null, slug?: string | null } | null }> } | null };

export type GetEditorialsEqualsCategoryIdQueryVariables = Exact<{
  editorialsPage: Scalars['Int']['input'];
  editorialsPageSize: Scalars['Int']['input'];
  locale: Scalars['I18NLocaleCode']['input'];
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type GetEditorialsEqualsCategoryIdQuery = { __typename?: 'Query', editorials?: { __typename?: 'EditorialEntityResponseCollection', meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, pageCount: number, pageSize: number, total: number } }, data: Array<{ __typename?: 'EditorialEntity', id?: string | null, attributes?: { __typename?: 'Editorial', title?: string | null, author?: string | null, slug?: string | null, createdAt?: any | null, publishedAt?: any | null, externalEntry?: string | null, mainImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, name: string, previewUrl?: string | null, url: string, height?: number | null, width?: number | null } | null } | null } | null, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, name: string, mime: string, height?: number | null, width?: number | null, url: string } | null } | null } | null, category?: { __typename?: 'EditorialCategoryEntityResponse', data?: { __typename?: 'EditorialCategoryEntity', attributes?: { __typename?: 'EditorialCategory', name?: string | null, slug?: string | null } | null } | null } | null } | null }> } | null };

export type HottestDropFragment = { __typename?: 'Query', hottestDrop?: { __typename?: 'HottestDropEntityResponse', data?: { __typename?: 'HottestDropEntity', id?: string | null, attributes?: { __typename?: 'HottestDrop', HottestOfDrops?: { __typename?: 'ComponentHottestDropsHottesOfDrops', id: string, campaign_link?: string | null, date?: string | null, headline?: string | null, name?: string | null, nft?: { __typename?: 'NftEntityResponse', data?: { __typename?: 'NftEntity', attributes?: { __typename?: 'Nft', tokenForge?: { __typename?: 'ComponentNftTokenForge', id: string, nftId?: string | null } | null } | null } | null } | null, gallery?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null } | null, HottestDrops?: Array<{ __typename?: 'ComponentHottestDropsHottestsDrops', id: string, nft?: { __typename?: 'NftEntityResponse', data?: { __typename?: 'NftEntity', attributes?: { __typename?: 'Nft', tokenForge?: { __typename?: 'ComponentNftTokenForge', id: string, nftId?: string | null } | null } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null> | null } | null } | null } | null };

export type GetHottestDropsWithHottestOfDropsQueryVariables = Exact<{
  publicationState?: InputMaybe<PublicationState>;
}>;


export type GetHottestDropsWithHottestOfDropsQuery = { __typename?: 'Query', hottestDrop?: { __typename?: 'HottestDropEntityResponse', data?: { __typename?: 'HottestDropEntity', id?: string | null, attributes?: { __typename?: 'HottestDrop', HottestOfDrops?: { __typename?: 'ComponentHottestDropsHottesOfDrops', id: string, campaign_link?: string | null, date?: string | null, headline?: string | null, name?: string | null, nft?: { __typename?: 'NftEntityResponse', data?: { __typename?: 'NftEntity', attributes?: { __typename?: 'Nft', tokenForge?: { __typename?: 'ComponentNftTokenForge', id: string, nftId?: string | null } | null } | null } | null } | null, gallery?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null } | null, HottestDrops?: Array<{ __typename?: 'ComponentHottestDropsHottestsDrops', id: string, nft?: { __typename?: 'NftEntityResponse', data?: { __typename?: 'NftEntity', attributes?: { __typename?: 'Nft', tokenForge?: { __typename?: 'ComponentNftTokenForge', id: string, nftId?: string | null } | null } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null> | null } | null } | null } | null };

export type NewArtistFragment = { __typename?: 'Query', newArtist?: { __typename?: 'NewArtistEntityResponse', data?: { __typename?: 'NewArtistEntity', attributes?: { __typename?: 'NewArtist', Artist?: Array<{ __typename?: 'ComponentArtistArtist', Name?: string | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | null } | null } | null };

export type GetNftByIdQueryVariables = Exact<{
  id?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetNftByIdQuery = { __typename?: 'Query', nfts?: { __typename?: 'NftEntityResponseCollection', meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } }, data: Array<{ __typename?: 'NftEntity', id?: string | null, attributes?: { __typename?: 'Nft', tokenForge?: { __typename?: 'ComponentNftTokenForge', id: string, nftId?: string | null } | null, tokenType?: { __typename?: 'ComponentNftTokenType', id: string, headline?: string | null, subHeadline?: string | null, description?: string | null } | null, background?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', id?: string | null, attributes?: { __typename?: 'UploadFile', name: string, alternativeText?: string | null, mime: string, url: string, previewUrl?: string | null } | null } | null } | null, nftContent?: { __typename?: 'ComponentNftNftContent', links?: Array<{ __typename?: 'ComponentNftContentLinks', id: string, description?: string | null, type?: Enum_Componentnftcontentlinks_Type | null, url?: string | null } | null> | null } | null } | null }> } | null };

export type GetNftsByIdsQueryVariables = Exact<{
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
}>;


export type GetNftsByIdsQuery = { __typename?: 'Query', nfts?: { __typename?: 'NftEntityResponseCollection', meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', total: number } }, data: Array<{ __typename?: 'NftEntity', id?: string | null, attributes?: { __typename?: 'Nft', tokenForge?: { __typename?: 'ComponentNftTokenForge', id: string, nftId?: string | null } | null, nftContent?: { __typename?: 'ComponentNftNftContent', links?: Array<{ __typename?: 'ComponentNftContentLinks', id: string, description?: string | null, type?: Enum_Componentnftcontentlinks_Type | null, url?: string | null } | null> | null } | null } | null }> } | null };

export type CmsFrontPageFragment = { __typename?: 'Query', hottestDrop?: { __typename?: 'HottestDropEntityResponse', data?: { __typename?: 'HottestDropEntity', id?: string | null, attributes?: { __typename?: 'HottestDrop', HottestOfDrops?: { __typename?: 'ComponentHottestDropsHottesOfDrops', id: string, campaign_link?: string | null, date?: string | null, headline?: string | null, name?: string | null, nft?: { __typename?: 'NftEntityResponse', data?: { __typename?: 'NftEntity', attributes?: { __typename?: 'Nft', tokenForge?: { __typename?: 'ComponentNftTokenForge', id: string, nftId?: string | null } | null } | null } | null } | null, gallery?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null } | null, HottestDrops?: Array<{ __typename?: 'ComponentHottestDropsHottestsDrops', id: string, nft?: { __typename?: 'NftEntityResponse', data?: { __typename?: 'NftEntity', attributes?: { __typename?: 'Nft', tokenForge?: { __typename?: 'ComponentNftTokenForge', id: string, nftId?: string | null } | null } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null> | null } | null } | null } | null, editorials?: { __typename?: 'EditorialEntityResponseCollection', data: Array<{ __typename?: 'EditorialEntity', id?: string | null, attributes?: { __typename?: 'Editorial', title?: string | null, author?: string | null, slug?: string | null, createdAt?: any | null, publishedAt?: any | null, externalEntry?: string | null, mainImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, name: string, previewUrl?: string | null, url: string, height?: number | null, width?: number | null } | null } | null } | null, content?: Array<{ __typename: 'ComponentEditorialGallery' } | { __typename: 'ComponentEditorialImage', id: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, name: string, previewUrl?: string | null, url: string, height?: number | null, width?: number | null } | null } | null } | null } | { __typename: 'ComponentEditorialIntro', id: string, text?: string | null } | { __typename: 'ComponentEditorialQuotation', id: string, text?: string | null } | { __typename: 'ComponentEditorialText', id: string, text?: string | null } | { __typename: 'Error' } | null> | null, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, name: string, mime: string, height?: number | null, width?: number | null, url: string } | null } | null } | null, category?: { __typename?: 'EditorialCategoryEntityResponse', data?: { __typename?: 'EditorialCategoryEntity', attributes?: { __typename?: 'EditorialCategory', name?: string | null, slug?: string | null } | null } | null } | null } | null }> } | null, whatWeDo?: { __typename?: 'WhatWeDoEntityResponse', data?: { __typename?: 'WhatWeDoEntity', attributes?: { __typename?: 'WhatWeDo', content?: Array<{ __typename?: 'ComponentWhatWeDoContent', id: string, description?: string | null, headline?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, button?: { __typename?: 'ComponentWhatWeDoButton', title?: string | null, link?: string | null } | null } | null> | null } | null } | null } | null, newArtist?: { __typename?: 'NewArtistEntityResponse', data?: { __typename?: 'NewArtistEntity', attributes?: { __typename?: 'NewArtist', Artist?: Array<{ __typename?: 'ComponentArtistArtist', Name?: string | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | null } | null } | null };

export type GetCmsFrontPageQueryVariables = Exact<{
  editorialsPage: Scalars['Int']['input'];
  editorialsPageSize: Scalars['Int']['input'];
  whatWeDoPage: Scalars['Int']['input'];
  whatWeDoPageSize: Scalars['Int']['input'];
  locale?: InputMaybe<Scalars['I18NLocaleCode']['input']>;
  publicationState?: InputMaybe<PublicationState>;
}>;


export type GetCmsFrontPageQuery = { __typename?: 'Query', hottestDrop?: { __typename?: 'HottestDropEntityResponse', data?: { __typename?: 'HottestDropEntity', id?: string | null, attributes?: { __typename?: 'HottestDrop', HottestOfDrops?: { __typename?: 'ComponentHottestDropsHottesOfDrops', id: string, campaign_link?: string | null, date?: string | null, headline?: string | null, name?: string | null, nft?: { __typename?: 'NftEntityResponse', data?: { __typename?: 'NftEntity', attributes?: { __typename?: 'Nft', tokenForge?: { __typename?: 'ComponentNftTokenForge', id: string, nftId?: string | null } | null } | null } | null } | null, gallery?: { __typename?: 'UploadFileRelationResponseCollection', data: Array<{ __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null }> } | null } | null, HottestDrops?: Array<{ __typename?: 'ComponentHottestDropsHottestsDrops', id: string, nft?: { __typename?: 'NftEntityResponse', data?: { __typename?: 'NftEntity', attributes?: { __typename?: 'Nft', tokenForge?: { __typename?: 'ComponentNftTokenForge', id: string, nftId?: string | null } | null } | null } | null } | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string } | null } | null } | null } | null> | null } | null } | null } | null, editorials?: { __typename?: 'EditorialEntityResponseCollection', data: Array<{ __typename?: 'EditorialEntity', id?: string | null, attributes?: { __typename?: 'Editorial', title?: string | null, author?: string | null, slug?: string | null, createdAt?: any | null, publishedAt?: any | null, externalEntry?: string | null, mainImage?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, name: string, previewUrl?: string | null, url: string, height?: number | null, width?: number | null } | null } | null } | null, content?: Array<{ __typename: 'ComponentEditorialGallery' } | { __typename: 'ComponentEditorialImage', id: string, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, mime: string, name: string, previewUrl?: string | null, url: string, height?: number | null, width?: number | null } | null } | null } | null } | { __typename: 'ComponentEditorialIntro', id: string, text?: string | null } | { __typename: 'ComponentEditorialQuotation', id: string, text?: string | null } | { __typename: 'ComponentEditorialText', id: string, text?: string | null } | { __typename: 'Error' } | null> | null, thumbnail?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', alternativeText?: string | null, name: string, mime: string, height?: number | null, width?: number | null, url: string } | null } | null } | null, category?: { __typename?: 'EditorialCategoryEntityResponse', data?: { __typename?: 'EditorialCategoryEntity', attributes?: { __typename?: 'EditorialCategory', name?: string | null, slug?: string | null } | null } | null } | null } | null }> } | null, whatWeDo?: { __typename?: 'WhatWeDoEntityResponse', data?: { __typename?: 'WhatWeDoEntity', attributes?: { __typename?: 'WhatWeDo', content?: Array<{ __typename?: 'ComponentWhatWeDoContent', id: string, description?: string | null, headline?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, button?: { __typename?: 'ComponentWhatWeDoButton', title?: string | null, link?: string | null } | null } | null> | null } | null } | null } | null, newArtist?: { __typename?: 'NewArtistEntityResponse', data?: { __typename?: 'NewArtistEntity', attributes?: { __typename?: 'NewArtist', Artist?: Array<{ __typename?: 'ComponentArtistArtist', Name?: string | null, Image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null } | null> | null } | null } | null } | null };

export type WhatWeDosFragment = { __typename?: 'Query', whatWeDo?: { __typename?: 'WhatWeDoEntityResponse', data?: { __typename?: 'WhatWeDoEntity', attributes?: { __typename?: 'WhatWeDo', content?: Array<{ __typename?: 'ComponentWhatWeDoContent', id: string, description?: string | null, headline?: string | null, image?: { __typename?: 'UploadFileEntityResponse', data?: { __typename?: 'UploadFileEntity', attributes?: { __typename?: 'UploadFile', url: string, alternativeText?: string | null } | null } | null } | null, button?: { __typename?: 'ComponentWhatWeDoButton', title?: string | null, link?: string | null } | null } | null> | null } | null } | null } | null };

export const HottestDropFragmentDoc = gql`
    fragment HottestDrop on Query {
  hottestDrop(publicationState: $publicationState) {
    data {
      attributes {
        HottestOfDrops {
          id
          campaign_link
          date
          headline
          name
          nft {
            data {
              attributes {
                tokenForge {
                  id
                  nftId
                }
              }
            }
          }
          gallery {
            data {
              attributes {
                url
              }
            }
          }
        }
      }
      id
      attributes {
        HottestDrops {
          id
          nft {
            data {
              attributes {
                tokenForge {
                  id
                  nftId
                }
              }
            }
          }
          image {
            data {
              attributes {
                url
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const EditorialsFragmentDoc = gql`
    fragment Editorials on Query {
  editorials(
    publicationState: $publicationState
    pagination: {page: $editorialsPage, pageSize: $editorialsPageSize}
    sort: "id:desc"
    locale: $locale
  ) {
    data {
      id
      attributes {
        title
        author
        slug
        createdAt
        publishedAt
        externalEntry
        mainImage {
          data {
            attributes {
              alternativeText
              mime
              name
              previewUrl
              url
              height
              width
            }
          }
        }
        content {
          __typename
          ... on ComponentEditorialIntro {
            id
            text
          }
          ... on ComponentEditorialText {
            id
            text
          }
          ... on ComponentEditorialQuotation {
            id
            text
          }
          ... on ComponentEditorialImage {
            id
            image {
              data {
                attributes {
                  alternativeText
                  mime
                  name
                  previewUrl
                  url
                  height
                  width
                }
              }
            }
          }
        }
        thumbnail {
          data {
            attributes {
              alternativeText
              name
              mime
              height
              width
              url
            }
          }
        }
        category {
          data {
            attributes {
              name
              slug
            }
          }
        }
      }
    }
  }
}
    `;
export const WhatWeDosFragmentDoc = gql`
    fragment WhatWeDos on Query {
  whatWeDo(publicationState: $publicationState) {
    data {
      attributes {
        content(pagination: {page: $whatWeDoPage, pageSize: $whatWeDoPageSize}) {
          id
          description
          headline
          image {
            data {
              attributes {
                url
                alternativeText
              }
            }
          }
          button {
            title
            link
          }
        }
      }
    }
  }
}
    `;
export const NewArtistFragmentDoc = gql`
    fragment NewArtist on Query {
  newArtist(locale: $locale, publicationState: $publicationState) {
    data {
      attributes {
        Artist {
          Name
          Image {
            data {
              attributes {
                url
                alternativeText
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const CmsFrontPageFragmentDoc = gql`
    fragment CmsFrontPage on Query {
  ...HottestDrop
  ...Editorials
  ...WhatWeDos
  ...NewArtist
}
    ${HottestDropFragmentDoc}
${EditorialsFragmentDoc}
${WhatWeDosFragmentDoc}
${NewArtistFragmentDoc}`;
export const GetCampaignByCampaignIdDocument = gql`
    query getCampaignByCampaignId($id: String, $locale: I18NLocaleCode, $currentNftsPage: Int!, $currentNftsPageSize: Int!) {
  campaigns(
    publicationState: PREVIEW
    filters: {tokenForge: {campaignId: {eq: $id}}}
    locale: $locale
  ) {
    data {
      id
      attributes {
        ctaButton {
          enable
          buttonTitle
        }
        newsletterID
        tokenForge {
          id
          campaignId
          Artists {
            id
            TokenForge_UUID
          }
        }
        Background {
          data {
            id
            attributes {
              url
              alternativeText
            }
          }
        }
        Video {
          data {
            id
            attributes {
              url
              alternativeText
            }
          }
        }
        Audio {
          data {
            id
            attributes {
              url
            }
          }
        }
        CurrentNft {
          id
          nftId
          title
          type
          headline
          subHeadline
          contents {
            id
            headline
            description
            imageAlt
            imageUrl {
              data {
                attributes {
                  url
                }
              }
            }
          }
        }
        currentNfts(
          pagination: {page: $currentNftsPage, pageSize: $currentNftsPageSize}
        ) {
          id
          nftId
          title
          type
          headline
          subHeadline
          contents {
            id
            headline
            description
            imageAlt
            imageUrl {
              data {
                attributes {
                  url
                }
              }
            }
          }
        }
        containedNfts {
          headline
          subHeadline
        }
        Roadmap {
          nftId
          headline
          subHeadline
          startAt
          startAtText
        }
        campaignContents {
          headline
          subHeadline
          image {
            data {
              attributes {
                url
                alternativeText
              }
            }
          }
          contents {
            headline
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                }
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetCampaignsDocument = gql`
    query getCampaigns {
  campaigns {
    data {
      id
      attributes {
        CurrentNft {
          nftId
        }
        tokenForge {
          id
          campaignId
        }
      }
    }
  }
}
    `;
export const GetClaimByIdDocument = gql`
    query getClaimById($id: String, $locale: I18NLocaleCode) {
  claimPages(
    publicationState: PREVIEW
    filters: {tokenForge: {pageSlug: {eq: $id}}}
    locale: $locale
  ) {
    data {
      attributes {
        tokenForge {
          nftId
        }
        image {
          data {
            attributes {
              url
              alternativeText
            }
          }
        }
        description {
          description
          headline
        }
      }
    }
  }
}
    `;
export const GetEditorialsEqualsSlugDocument = gql`
    query getEditorialsEqualsSlug($slug: String!, $locale: I18NLocaleCode!) {
  editorials(filters: {slug: {eq: $slug}}, locale: $locale) {
    data {
      id
      attributes {
        title
        author
        slug
        createdAt
        publishedAt
        mainImage {
          data {
            attributes {
              alternativeText
              mime
              name
              previewUrl
              url
              height
              width
            }
          }
        }
        content {
          __typename
          ... on ComponentEditorialIntro {
            id
            text
          }
          ... on ComponentEditorialText {
            id
            text
          }
          ... on ComponentEditorialQuotation {
            id
            text
          }
          ... on ComponentEditorialImage {
            id
            image {
              data {
                attributes {
                  alternativeText
                  mime
                  name
                  previewUrl
                  url
                  height
                  width
                }
              }
            }
          }
        }
        thumbnail {
          data {
            attributes {
              alternativeText
              name
              mime
              height
              width
              url
            }
          }
        }
        category {
          data {
            attributes {
              name
              slug
            }
          }
        }
      }
    }
  }
}
    `;
export const GetEditorialCategoriesDocument = gql`
    query getEditorialCategories($locale: I18NLocaleCode!) {
  editorialCategories(publicationState: LIVE, sort: "id:desc", locale: $locale) {
    data {
      id
      attributes {
        name
        slug
      }
    }
  }
}
    `;
export const GetEditorialsEqualsCategoryIdDocument = gql`
    query getEditorialsEqualsCategoryId($editorialsPage: Int!, $editorialsPageSize: Int!, $locale: I18NLocaleCode!, $categoryId: ID, $publicationState: PublicationState) {
  editorials(
    pagination: {page: $editorialsPage, pageSize: $editorialsPageSize}
    filters: {category: {id: {eq: $categoryId}}}
    sort: "id:desc"
    locale: $locale
    publicationState: $publicationState
  ) {
    meta {
      pagination {
        page
        pageCount
        pageSize
        total
      }
    }
    data {
      id
      attributes {
        title
        author
        slug
        createdAt
        publishedAt
        externalEntry
        mainImage {
          data {
            attributes {
              alternativeText
              mime
              name
              previewUrl
              url
              height
              width
            }
          }
        }
        thumbnail {
          data {
            attributes {
              alternativeText
              name
              mime
              height
              width
              url
            }
          }
        }
        category {
          data {
            attributes {
              name
              slug
            }
          }
        }
      }
    }
  }
}
    `;
export const GetHottestDropsWithHottestOfDropsDocument = gql`
    query getHottestDropsWithHottestOfDrops($publicationState: PublicationState) {
  ...HottestDrop
}
    ${HottestDropFragmentDoc}`;
export const GetNftByIdDocument = gql`
    query getNftById($id: String, $locale: I18NLocaleCode) {
  nfts(
    publicationState: PREVIEW
    locale: $locale
    filters: {tokenForge: {nftId: {eq: $id}}}
  ) {
    meta {
      pagination {
        total
      }
    }
    data {
      id
      attributes {
        tokenForge {
          id
          nftId
        }
        tokenType {
          id
          headline
          subHeadline
          description
        }
        background {
          data {
            id
            attributes {
              name
              alternativeText
              mime
              url
              previewUrl
            }
          }
        }
        nftContent {
          links {
            id
            description
            type
            url
          }
        }
      }
    }
  }
}
    `;
export const GetNftsByIdsDocument = gql`
    query getNftsByIds($ids: [String], $locale: I18NLocaleCode) {
  nfts(
    publicationState: PREVIEW
    locale: $locale
    filters: {tokenForge: {nftId: {in: $ids}}}
  ) {
    meta {
      pagination {
        total
      }
    }
    data {
      id
      attributes {
        tokenForge {
          id
          nftId
        }
        nftContent {
          links {
            id
            description
            type
            url
          }
        }
      }
    }
  }
}
    `;
export const GetCmsFrontPageDocument = gql`
    query getCmsFrontPage($editorialsPage: Int!, $editorialsPageSize: Int!, $whatWeDoPage: Int!, $whatWeDoPageSize: Int!, $locale: I18NLocaleCode, $publicationState: PublicationState) {
  ...CmsFrontPage
}
    ${CmsFrontPageFragmentDoc}`;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    getCampaignByCampaignId(variables: GetCampaignByCampaignIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCampaignByCampaignIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCampaignByCampaignIdQuery>(GetCampaignByCampaignIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCampaignByCampaignId', 'query');
    },
    getCampaigns(variables?: GetCampaignsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCampaignsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCampaignsQuery>(GetCampaignsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCampaigns', 'query');
    },
    getClaimById(variables?: GetClaimByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetClaimByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetClaimByIdQuery>(GetClaimByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getClaimById', 'query');
    },
    getEditorialsEqualsSlug(variables: GetEditorialsEqualsSlugQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEditorialsEqualsSlugQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEditorialsEqualsSlugQuery>(GetEditorialsEqualsSlugDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getEditorialsEqualsSlug', 'query');
    },
    getEditorialCategories(variables: GetEditorialCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEditorialCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEditorialCategoriesQuery>(GetEditorialCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getEditorialCategories', 'query');
    },
    getEditorialsEqualsCategoryId(variables: GetEditorialsEqualsCategoryIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetEditorialsEqualsCategoryIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetEditorialsEqualsCategoryIdQuery>(GetEditorialsEqualsCategoryIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getEditorialsEqualsCategoryId', 'query');
    },
    getHottestDropsWithHottestOfDrops(variables?: GetHottestDropsWithHottestOfDropsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetHottestDropsWithHottestOfDropsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetHottestDropsWithHottestOfDropsQuery>(GetHottestDropsWithHottestOfDropsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getHottestDropsWithHottestOfDrops', 'query');
    },
    getNftById(variables?: GetNftByIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetNftByIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNftByIdQuery>(GetNftByIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getNftById', 'query');
    },
    getNftsByIds(variables?: GetNftsByIdsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetNftsByIdsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetNftsByIdsQuery>(GetNftsByIdsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getNftsByIds', 'query');
    },
    getCmsFrontPage(variables: GetCmsFrontPageQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCmsFrontPageQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCmsFrontPageQuery>(GetCmsFrontPageDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCmsFrontPage', 'query');
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;